import { render, staticRenderFns } from "./ClinicOversightProducts.vue?vue&type=template&id=0ab1fdee&"
import script from "./ClinicOversightProducts.vue?vue&type=script&lang=js&"
export * from "./ClinicOversightProducts.vue?vue&type=script&lang=js&"
import style0 from "./ClinicOversightProducts.vue?vue&type=style&index=0&id=0ab1fdee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports